import { store } from "store/index";
import { getLocalStore } from "./localStorage";
import { Constants } from "utils";

// To retrieve dashboard privileges
const Role = (function () {
  const getDashboardType = () =>
    store.getState().auth?.user?.dashboardType ??
    getLocalStore()?.dashboardType ??
    null;

  const getId = () =>
    store.getState().auth?.user?.identifier ??
    getLocalStore()?.identifier ??
    null;

  const adminAccess = () =>
    (getDashboardType() === Constants.dashboardRoles.admin) || (getDashboardType() === Constants.dashboardRoles.admin_2);

  const admin_2_Access = () =>
    getDashboardType() === Constants.dashboardRoles.admin_2;

  const careHomeAccess = () =>
    getDashboardType() === Constants.dashboardRoles.careHome;

  const caregiverAccess = () =>
    getDashboardType() === Constants.dashboardRoles.caregiver;

  return {
    getId,
    adminAccess,
    admin_2_Access,
    careHomeAccess,
    caregiverAccess,
  };
})();

export default Role;
